import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import { PriceFormat } from "../scripts/helpers";
// import QRCode from "react-qr-code";
import { useEffect } from "react";
var Barcode = require('react-barcode');
let counter =0;
class FactorPrint extends Component {
  constructor() {
    super();
    this.state = {
      factor: [],
      newRow: [],
      orderItem: [],

    };
    this.barcodeRef = React.createRef();

  }
  //
  handleClick = () => {
    // React.useEffect(() => {
    //   this.barcodeRef.current.scrollTo(0, 0);
    // }, []);
    // if (this.barcodeRef.current) {
    //   this.barcodeRef.current.scrollIntoView();
    // }
    // setTimeout(() => {
    //   this.barcodeRef.current.scrollIntoView();
    // }, 600)

  }



  render() {
    const { detail } = this.props;
   

    return (
        <div>
          <form ref={this.barcodeRef} className="container container-print pb-3">
            <div className="row">

              <div className="col-12 text-center">

                <table className="table table-bordered w-100 mt-2" style={{border:"none"}}>
                  <tbody>
                  { (detail.range) && (detail.range.length) &&  detail.range.map((item, i) => (
                    
                      <>
                       {console.log(detail.range[i])}
                        { (i % 2 === 0) &&
                        <>
                          {i == 0 ?
                              <tr key={`key:${i}`} style={{border: "none", height: "50vh"}}>
                                {
                                  detail.range[i] != undefined &&
                                  <th style={{ border: "none"}}>

                                <span className="row" style={{
                                  fontSize: "18px",
                                  justifyContent: "center"
                                }}><i>{`${detail.name} `}</i></span>
                                    <Barcode
                                        value={detail.range[i]["barcode_hash"]}
                                        format="CODE128"
                                      // renderer="svg"
                                      //   width={1.8}
                                      //   // height={60}
                                      //   margin={0}
                                        displayValue={false}
                                    />
                                    <div
                                        style={{
                                          marginTop: "2px",
                                          fontSize: "18px",
                                          // fontWeight: "bold"
                                        }}
                                      >
                                        {detail.range[i]["barcode"]}
                                      </div>
                                  </th>
                                }
                                {
                                  detail.range[i + 1] != undefined &&
                                  <th style={{ border: "none"}}>
                                <span className="row" style={{
                                  fontSize: "18px",
                                  justifyContent: "center"
                                }}><i>{`${detail.name} `}</i></span>
                                    <Barcode
                                        value={detail.range[i + 1]["barcode_hash"]}
                                        format="CODE128"
                                      //     renderer="svg"
                                      // width={1.8}
                                      // // height={60}
                                      // margin={0}
                                      displayValue={false}
                                    />
                                    <div
                                        style={{
                                          marginTop: "2px",
                                          fontSize: "18px",
                                          // fontWeight: "bold"
                                        }}
                                      >
                                        {detail.range[i + 1]["barcode"]}
                                      </div>
                                  </th>

                                }
                              </tr>


                              :

                              <tr key={`key:${i}`} style={{border: "none", height: "100vh", paddingLeft:"0px"}}>
                                {
                                  detail.range[i] != undefined &&
                                  <th style={{ border: "none"}}>

                                <span className="row" style={{
                                  fontSize: "18px",
                                  justifyContent: "center"
                                }}><i>{`${detail.name} `}</i></span>

                                    {/*<div style={{marginLeft:"1px"}}>*/}
                                    <Barcode
                                        value={detail.range[i]["barcode_hash"]}
                                        format="CODE128"
                                      // renderer="svg"
                                      //   width={1.8}
                                      //   // height={60}
                                      //   margin={0}
                                        displayValue={false}
                                    />
                                    {/*</div>*/}
                                    <div
                                        style={{
                                          marginTop: "2px",
                                          fontSize: "18px",
                                          // fontWeight: "bold"
                                        }}
                                      >
                                        {detail.range[i]["barcode"]}
                                      </div>

                                  </th>
                                }
                                {
                                  detail.range[i + 1] != undefined &&
                                  <th style={{ border: "none"}}>
                                <span className="row" style={{
                                  fontSize: "18px",
                                  justifyContent: "center"
                                }}><i>{`${detail.name} `}</i></span>
                                    <Barcode
                                        value={detail.range[i + 1]["barcode_hash"]}
                                        format="CODE128"
                                    // renderer="svg"
                                    //   width={1.8}
                                    //   // height={60}
                                    //   margin={0}
                                      displayValue={false}
                                    />
                                     <div
                                        style={{
                                          marginTop: "2px",
                                          fontSize: "18px",
                                          // fontWeight: "bold"
                                        }}
                                      >
                                        {detail.range[i + 1]["barcode"]}
                                      </div>
                                  </th>

                                }
                              </tr>
                          }

                        </>
                        }
                      </>
                  ))}
                  </tbody>
                </table>

              </div>
            </div>
            {/*</div>*/}
          </form>

          {/*<div className="col-12 pt-5 text-center">*/}
          {/*  <button className="print_btn"*/}
          {/*      // onClick={this.handleClick}*/}
          {/*      onClick={() =>*/}
          {/*          this.barcodeRef.current.scrollIntoView({ behavior: "smooth", block: "start" })*/}
          {/*      }*/}
          {/*  >*/}
          {/*    Scroll to top*/}
          {/*  </button>*/}
          {/*</div>*/}
        </div>

    );
  }
}
class PrintComponent extends React.Component {
  render() {
    return (
      <div className="container text-center">
        <div className="row">
          <div className="col-md-12">
            <FactorPrint
              detail={this.props.printDetail}
              ref={(el) => (this.componentRef = el)}
            />
          </div>
          <div className="col-md-12">
            <ReactToPrint
              // copyStyles
              trigger={() => (
                    <button
                      data-dismiss="modal"
                      className="btn btn-none-box btn-info border-radius-lg border-md color-light mt-5"
                    >
                      پرینت فاکتور
                    </button>
              )}
              bodyClass="rtl"
              content={() => this.componentRef}
            />

          </div>
        </div>
      </div>
    );
  }
}

export default PrintComponent;
